import Marquee from 'react-fast-marquee';

import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';

function ImageSlider({ blok }) {
  const gallery = blok.images || [];
  const mobileGallery = blok.mobileSliderImages || [];
  return (
    <div {...storyblokEditable(blok)}>
      <div className="pt-8 pb-[100px] hidden md:block">
        <Marquee speed={80} pauseOnClick>
          {[...gallery, ...gallery].map(({ filename, alt }, i) => (
            <div
              className={
                      clsx(`inline-block ${filename}`, i > 0 ? 'ml-4' : '')
                    }
              style={{ height: '450px' }}
                    // eslint-disable-next-line react/no-array-index-key
              key={`gallery-loop-${i}-${filename}`}
            >
              <img
                className="bg-green-600 object-cover h-full"
                src={filename}
                alt={alt}
              />
            </div>
          ))}
        </Marquee>
      </div>
      <div className="pt-8 pb-[100px] block md:hidden">
        <Marquee speed={80} pauseOnClick>
          {[...mobileGallery, ...mobileGallery].map(({ filename, alt }, i) => (
            <div
              className={
                      clsx('inline-block', i > 0 ? 'ml-4' : '')
                    }
              style={{ height: '200px' }}
                    // eslint-disable-next-line react/no-array-index-key
              key={`gallery-loop-${i}`}
            >
              {filename && (
                <img
                  className="bg-green-600 max-h-[200px] md:object-none object-contain h-full"
                  src={filename}
                  alt={alt}
                />
              )}
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
}

export default ImageSlider;
